module.exports = __webpack_public_path__ + "img/madlena-tsvetkova-p.5ef20a64.jpg";